/**
 * Possible values for requests related to AT.
 */
 
export const AT_TYPE = 'AT';
export const AT_CONTEXT_SEQUENCES = 'Sequences';